import { render, staticRenderFns } from "./DeadlineEditor.vue?vue&type=template&id=bec54f56"
import script from "./DeadlineEditor.vue?vue&type=script&lang=js"
export * from "./DeadlineEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports